document.addEventListener('DOMContentLoaded', function () {
  var $card = $('.berlin-marathon-product-card-card');

  function activateVariant($item) {
    if (!$item || !$item.length) return;
    var vid = $item.attr('data-id');
    var vindex = $item.attr('data-index');
    var pid = $item.attr('data-pid');

    $item.addClass('active').attr('aria-selected', 'true');
    $item.siblings('.variant-item').removeClass('active').attr('aria-selected', 'false');
    $card.find('.variant-wrapper[data-id="' + vid + '"]').addClass('active').siblings().removeClass('active');
    $card
      .find('.variant-img[data-index="' + vindex + '"][data-pid="' + pid + '"]')
      .addClass('active')
      .siblings()
      .removeClass('active');
    $card
      .find('.buy-card .price[data-index="' + vindex + '"][data-pid="' + pid + '"]')
      .addClass('active')
      .siblings()
      .removeClass('active');

    var isCollab = $item.attr('data-collab') === 'true';
    var isAvailable = $item.attr('data-available') === 'true';
    var $buyCard = $card.find('.buy-card');
    var wasCollab = $buyCard.hasClass('is-collab');
    $buyCard.toggleClass('is-collab', isCollab).toggleClass('is-regular', !isCollab);
    $buyCard.toggleClass('collab-in-stock', isCollab && isAvailable);
    $buyCard.toggleClass('collab-sold-out', isCollab && !isAvailable);
    $buyCard.attr('data-variant-id', vid);
    $card.find('.card-badge').toggleClass('is-collab', isCollab).toggleClass('is-regular', !isCollab);
    $card
      .find('.product-indfo-desc')
      .toggleClass('is-collab', isCollab && isAvailable)
      .toggleClass('is-sold-out', isCollab && !isAvailable);
    if (wasCollab !== isCollab) {
      initProductCardSwiper(isCollab);
    }
  }

  function showColorsForSize(now_product, now_size) {
    var $items = $card.find('.' + now_product + ' .color_list .variant-item');
    $items.hide();
    var $visible = $items.filter('[data-option-size="' + now_size + '"]');
    if (!$card.hasClass('collab-line-sold-out')) {
      $visible = $visible.filter('[data-collab="true"]');
    }
    $visible.css('display', 'block');
    var $target = $visible.filter('.active');
    if ($card.hasClass('collab-line-sold-out') && (!$target.length || $target.attr('data-collab') === 'true')) {
      $target = $visible.filter('[data-collab="false"]').eq(0);
    }
    if (!$target.length) $target = $visible.eq(0);
    activateVariant($target);
  }

  $card.on('click', '.color_list .variant-item', function () {
    activateVariant($(this));
  });

  $card.on(
    'click',
    '.buy-card.openrun-pro2 .toggle-product-option-size .toggle-product-option-item',
    function (e) {
      e.stopPropagation();
      var now_product = $(this).attr('data-product-handle');
      var now_size = $(this).attr('data-option-size');
      $(this).addClass('active').siblings().removeClass('active');
      showColorsForSize(now_product, now_size);
    }
  );

  var productCardSwiper = null;

  function initProductCardSwiper(isCollab) {
    if (window.innerWidth > 768) return;
    var el = $card.find('.swiper-container')[0];
    if (!el) return;

    if (productCardSwiper && typeof productCardSwiper.destroy === 'function') {
      productCardSwiper.destroy(true, true);
      productCardSwiper = null;
    }

    productCardSwiper = new Swiper(el, {
      slidesPerView: 1,
      autoplay: isCollab ? { delay: 3000 } : false,
      loop: !!isCollab,
      pagination: isCollab
        ? {
            el: '.berlin-marathon-product-card-card .swiper-pagination',
            clickable: true,
          }
        : false,
    });
  }

  if (window.innerWidth <= 768) {
    initProductCardSwiper($card.find('.buy-card').hasClass('is-collab'));
  }

  // 跑马灯
  function initTitleContentMarquee() {
    var track = document.querySelector('.title-content-li');
    if (!track || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (track._marqueeInit) return;

    var wrap = document.createElement('div');
    wrap.className = 'title-content-li-marquee';
    track.parentNode.replaceChild(wrap, track);
    wrap.appendChild(track);
    track._marqueeInit = true;

    var cloned = false;
    function apply() {
      var overflow = track.scrollWidth > wrap.clientWidth;
      if (overflow) {
        if (!cloned) {
          track.innerHTML += track.innerHTML;
          cloned = true;
        }
        track.classList.add('is-marquee');
      } else {
        if (cloned) {
          var half = track.children.length / 2;
          while (track.children.length > half) track.removeChild(track.lastChild);
          cloned = false;
        }
        track.classList.remove('is-marquee');
      }
    }
    apply();
    window.addEventListener('resize', apply);
  }
  initTitleContentMarquee();
  function getCardDiscount(card) {
    const variant = card.querySelector('.variant-wrapper.active');
    if (!variant) return 0;
    const price = Number(variant.getAttribute('data-price')) || 0;
    const compareAtPrice = Number(variant.getAttribute('data-compprice')) || 0;
    if (compareAtPrice <= price) return 0;
    return +(((compareAtPrice - price) / 100).toFixed(2));
  }
  function buildItem(card) {
    const el = card.querySelector('.variant-wrapper.active .product-data-div');
    if (!el) return null;
    const d = el.getAttribute('data-product-data').split('::');

    let $v_item_name = '';
    let $v_item_variant = '';
    let $v_item_category = '';
    let $v_item_category2 = 'Standard';
    
    if (product_handle_map && product_handle_map.has(d[0])) {
      $v_item_name = product_handle_valueMap[d[0]][0];
      $v_item_variant = product_handle_valueMap[d[0]][1];
      $v_item_category = product_handle_valueMap[d[0]][2];
      $v_item_category2 = product_handle_valueMap[d[0]][3];
    }
    return {
      item_id: d[0],
      item_name: $v_item_name,
      index: Number(d[2]) + 1,
      item_list_id: 'bl_marathon',
      item_list_name: 'bl_marathon',
      item_category: $v_item_category,
      item_category2: $v_item_category2,
      item_category3: d[6].replace('Default Title', 'none'),
      item_variant: $v_item_variant,
      item_brand: 'SHOKZ',
      price: Number(d[9].split('€').join('').split(',').join('.')),
      quantity: Number(d[10]),
      currency: 'EUR',
      discount: getCardDiscount(card)
    };
  }

  function pushGaEvent(eventName, item, extra) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: eventName,
      event_parameters: {
        currency: item.currency,
        item_list_id: item.item_list_id,
        item_list_name: item.item_list_name,
        items: [item],
        ...extra
      }
    });
  }
  const card = document.querySelector('.berlin-marathon-product-card-card');
  if (!card) return;

  const firedList = new Set();
  const impressionKey = location.pathname + '|berlin-marathon';

  function isCardBottomInView() {
    const rect = card.getBoundingClientRect();
    return rect.bottom > 0 && rect.bottom <= window.innerHeight;
  }

  function fireImpression() {
    if (firedList.has(impressionKey) || !isCardBottomInView()) return false;
    firedList.add(impressionKey);
    const item = buildItem(card);
    if (item) pushGaEvent('view_item_list', item);
    return true;
  }

  function stopWatching() {
    io.disconnect();
    document.removeEventListener('scroll', onScrollOrResize, true);
    window.removeEventListener('resize', onScrollOrResize);
  }

  function onScrollOrResize() {
    if (fireImpression()) stopWatching();
  }

  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        document.removeEventListener('scroll', onScrollOrResize, true);
        window.removeEventListener('resize', onScrollOrResize);
        return;
      }
      if (fireImpression()) {
        stopWatching();
        return;
      }
      document.addEventListener('scroll', onScrollOrResize, { capture: true, passive: true });
      window.addEventListener('resize', onScrollOrResize);
    });
  }, { threshold: 0 });

  io.observe(card);

  $(".berlin-marathon-product-card-card .variants-img-wrapper,.berlin-marathon-product-card-card .product-info-wrapper,.berlin-marathon-product-card-card .buy-card .add-to-cart-form2 a.product-link").on("click", function (e) {
    e.preventDefault();
    pushGaEvent('select_item', buildItem(card));
    window.location.href = $(this).attr('href');
  })

  $('.berlin-marathon-product-card-card .add-to-cart-form2').on('submit', function (evt) {
    evt.preventDefault();
    ShopifyAPI.addItemFromForm2(evt.target, ajaxCart.itemAddedCallback, ajaxCart.itemErrorCallback);
    pushGaEvent('add_to_cart', buildItem(card));
  });

})
